export default __webpack_public_path__ + "static/media/AWS-Certified-Cloud-Practitioner-certificate.6a1385ba.pdf";